import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { AppliedFilterRow } from '../../components/lister/applied-filters/AppliedFilterRow';
import { filterActions } from '../../redux/filter/actions/FilterActions.creators';
import { makeGetFlattenedActiveFiltersState } from '../../redux/lister/selectors/ListerSelector';
export const AppliedFilterContainer = () => {
    const dispatch = useDispatch();
    const flattenedActiveFilters = useSelector((state) => makeGetFlattenedActiveFiltersState()(state));
    const toggleFilter = (toggledFilter) => dispatch(filterActions.updateFilters(toggledFilter));
    const removeAllFilters = () => dispatch(filterActions.removeAllFilters());
    return (_jsx(AppliedFilterRow, { flattenedActiveFilters: flattenedActiveFilters, onToggleFilter: toggleFilter, onRemoveAllFilters: removeAllFilters }));
};
